module.exports = __webpack_public_path__ + "c94a6f5f89507eb167b4635ac489b969.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/profile/perfil/images/back.png
// module id = 390
// module chunks = 0